
import { reactive, ref } from "vue"
import { useRoute } from "vue-router"
import { useStore } from "vuex"

export default {
  name: 'List',
  setup(_props: any, { emit }: any) {
    const store = useStore()
    const route = useRoute()
    const state = reactive({
      loading: false,
      finished: false,
      refreshing: false
    })

    const list = ref()

    const getScrollTop = () => {
      return list.value.$el.scrollTop
    }

    const setScrollTop = (scrollTop: number) => {
      list.value.$el.scrollTop = scrollTop
    }

    const onLoad = () => {
      if (state.refreshing) {
        state.loading = true
        state.refreshing = false
      } else {
        state.loading = true
      }
      emit('onLoad', (isFinished = false) => {
        state.refreshing = false
        state.loading = false
        state.finished = isFinished
      })
    }

    const onRefresh = () => {
      // 清空列表数据
      state.finished = false
      emit('onRefresh')
      state.loading = true
      onLoad()
    }

    const setFinishedFalse = () => {
      state.finished = false
      onLoad()
    }

    return {
      list,
      state,
      onLoad,
      onRefresh,
      setFinishedFalse,
      getScrollTop,
      setScrollTop
    }
  }
}
